// @ts-nocheck

import { NetworkActionTypes } from '../../types/actions/network';

let requests = [];

export const handledActionTypes = [NetworkActionTypes.SEND, NetworkActionTypes.RECV];

const oneBetslipMiddlewareHandler = ({ action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === NetworkActionTypes.SEND && 'getOneBetslip' in action.payload) {
      requests.push(action.payload.getOneBetslip.betslipReference);
    }

    if (action.type === NetworkActionTypes.RECV) {
      if ('betslips' in action.payload && 'nbBetslips' in action.payload && 'betslipIds' in action.payload) {
        const { betslips, betslipIds, nbBetslips, ...rest } = action.payload;

        if (nbBetslips === 1) {
          if (
            Object.keys(betslips)
              .map((id) => betslips[id].betslipReference)
              .filter((reference) => requests.indexOf(reference) !== -1).length
          ) {
            requests = requests.filter((reference) => reference !== betslips[betslipIds[0]].betslipReference);
            action.payload = {
              ...rest,
              betslips,
            };
          }
        }
      }
    }
  }
};

export default oneBetslipMiddlewareHandler;
